import { type ComponentPropsWithoutRef } from 'react';

import { BUTTON_SIZE } from '@/components/ui/types/button-variants-enums';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

interface SubmitButtonProps extends ComponentPropsWithoutRef<typeof Button> {
  loading?: boolean;
}

export function SubmitButton({
  children,
  loading,
  disabled,
  className = 'w-full',
  ...rest
}: SubmitButtonProps) {
  return (
    <Button
      type="submit"
      size={BUTTON_SIZE.LARGE}
      className={cn(
        'transition-transform duration-standard ease-standard motion-safe:active:scale-[0.98]',
        className
      )}
      disabled={disabled ?? loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <Spinner size="small" className="mr-2 text-primary-foreground" /> : null}
      {children}
    </Button>
  );
}
